export default "__VITE_ASSET__806c3a08__"